<div class="modal-header">
  <h4 class="modal-title text-capitalize">{{ ACTION_LABEL[action()] }} License
  </h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="d-grid gap-3 my-3" style="grid-template-columns: repeat(2, 1fr)">
      <app-select-business-license class="full-width-grid-item" [(businessId)]="businessId" [lockSelection]="lockBusiness" [branchId]="businessBranch().Id"></app-select-business-license>
      <mat-form-field subscriptSizing="dynamic" class="w-100">
        <mat-label>Valid From</mat-label>
        <input matInput [matDatepicker]="validSince" name="validSince" [(ngModel)]="license().ValidSince" />
        <mat-datepicker-toggle matSuffix [for]="validSince"></mat-datepicker-toggle>
        <mat-datepicker #validSince></mat-datepicker>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="w-100">
        <mat-label>Valid Until</mat-label>
        <input matInput [min]="minDate" [matDatepicker]="validUntil" name="validUntil" [(ngModel)]="license().ValidUntil" />
        <mat-datepicker-toggle matSuffix [for]="validUntil"></mat-datepicker-toggle>
        <mat-datepicker #validUntil></mat-datepicker>
      </mat-form-field>
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="license().AccountNo" id="accountNo" placeholder="Account No." />
        <label for="accountNo" class="form-label">Account No.</label>
      </div>
      <div class="full-width-grid-item d-flex align-items-center justify-content-between">
      @if (sharedService.isBossAccount()) {
        <div class="form-check form-switch fs-5 fw-medium">
          <input class="form-check-input" type="checkbox" id="overrideBranchInfo" name="overrideBranchInfo" [(ngModel)]="overrideBranchInfo" />
          <label class="form-check-label" for="overrideBranchInfo">Override License</label>
        </div>
      }
      @if (infoMismatch()) {
        <div class="text-end flex-grow-1"><span class="fs-6 badge bg-danger-subtle text-danger-emphasis"><i class="fas fa-exclamation-triangle"></i> Mismatch</span></div>
      }
      </div>
      <div class="form-floating">
        <input type="text" required [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().ContactNo" (ngModelChange)="onContactNoChanged($event)" id="contact" placeholder="Contact No." [readOnly]="!overrideBranchInfo()" />
        <label for="contact" class="form-label">Contact No.</label>
      </div>
      <div class="form-floating">
        <input type="email" [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Email" (ngModelChange)="onEmailChanged($event)" id="email" placeholder="Email No." onblur="this.reportValidity()" [readOnly]="!overrideBranchInfo()" />
        <label for="email" class="form-label">Email</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" required [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.Line0" (ngModelChange)="onAddressLine0Changed($event)" id="line0" placeholder="Address Line 1" [readOnly]="!overrideBranchInfo()" />
        <label for="line0" class="form-label">Address Line 1</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.Line1" (ngModelChange)="onAddressLine1Changed($event)" id="line1" placeholder="Address Line 2" [readOnly]="!overrideBranchInfo()" />
        <label for="line1" class="form-label">Address Line 2</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.Line2" (ngModelChange)="onAddressLine2Changed($event)" id="line2" placeholder="Address Line 3" [readOnly]="!overrideBranchInfo()" />
        <label for="line2" class="form-label">Address Line 3</label>
      </div>
      <div class="form-floating">
        <input type="text" required [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.PostalZone" (ngModelChange)="onPostalZoneChanged($event)" id="postcode" placeholder="Postcode" (keypress)="sharedService.isNumberKey($event)" pattern="\d{5}" onblur="this.reportValidity()" title="5 digits postcode" [readOnly]="!overrideBranchInfo()" />
        <label for="postcode" class="form-label">Postcode</label>
      </div>
      <div class="form-floating">
        <input type="text" required [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.City" (ngModelChange)="onCityChanged($event)" id="city" placeholder="City" [readOnly]="!overrideBranchInfo()" />
        <label for="city" class="form-label">City</label>
      </div>
      <div class="form-floating">
        <input type="text" required [class]="overrideBranchInfo() ? 'form-control' : 'form-control-plaintext'" [ngModel]="license().Address.State" (ngModelChange)="onStateChanged($event)" id="state" placeholder="State" [readOnly]="!overrideBranchInfo()" />
        <label for="state" class="form-label">State</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <textarea class="form-control" [(ngModel)]="license().Remark" placeholder="Remark" id="remark" style="height: 100px"></textarea>
        <label for="remark">Remark</label>
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-between gap-2">
    @if (infoMismatch()) {
      <div class="text-danger fw-semibold">Contact No, Email or Address does not match branch info!</div>
    }
      <div class="flex-grow-1 d-flex justify-content-end gap-2">
      @if (infoMismatch()) {
        <button class="btn btn-outline-primary" (click)="addOrUpdateLicense(true)">{{ ACTION_LABEL[action()] }} With Branch Info</button>
      }
        <button class="btn btn-light" (click)="resetLicense()">Reset</button>
        <button class="btn btn-primary" (click)="addOrUpdateLicense()">{{ ACTION_LABEL[action()] }}</button>
      </div>
    </div>
  </div>
</div>
